(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["nov-product-recommendations"]) return;
  try {
    

class ProductRecommendations extends HTMLElement {
  constructor() {
    super();
  }

  connectedCallback() {

    const handleIntersection = (entries, observer) => {

      if (!entries[0].isIntersecting) return;

      observer.unobserve(this);

      fetch(this.dataset.url)
        .then(response => response.text())
        .then(text => {

          const html = document.createElement('div');
          html.innerHTML = text;

          const recommendations = html.querySelector('product-recommendations');

          if (!recommendations?.querySelector('.item-product')) {
            this.closest('.shopify-section')?.setAttribute('hidden', '');
            return;
          }
          if (recommendations) {
            this.innerHTML = recommendations.innerHTML;

            new Swiper(this, {

              slidesPerView: 4,
              spaceBetween: 1,

              navigation: {
                nextEl: this.querySelector('.swiper-button-next'),
                prevEl: this.querySelector('.swiper-button-prev'),
              },

              breakpoints: {
                320: { slidesPerView: 1.5 },
                480: { slidesPerView: 2 },
                768: { slidesPerView: 3 },
                1024: { slidesPerView: 4 }
              }

            });
            if (window.pgCarouselInit) window.pgCarouselInit(this);
            if (window.pgSwatchInit) window.pgSwatchInit(this);

          }

          Currency.convertAll(shopCurrency, $('#currencies span.selected').attr('data-currency'));

          if ($('.jdgm-widget').length) {
            jdgm.customizeBadges()
          }

        })
        .catch(e => {
          console.error(e);
        });

    }

    new IntersectionObserver(handleIntersection.bind(this), {
      rootMargin: '0px 0px 200px 0px'
    }).observe(this);

  }
}

customElements.define('product-recommendations', ProductRecommendations);


  } catch(e) { console.error(e); }
})();
})();
